import Body1 from '@components/typography/Body1';

const HeroSubheading = () => {
  return (
    <Body1>
      Whether you qualify for Medicaid, have an Obamacare subsidy, or need to pay full price for an ACA plan: We
      rigorously sort through hundreds of options for the one that fits you best.
    </Body1>
  );
};

export default HeroSubheading;
